import { mapContextBlock } from '../../../_blocks/mapContextBlock';
import { asDefaultWidget } from './asDefaultWidget';

export const DefaultContextWidget = asDefaultWidget(mapContextBlock);
